<template>
    <Breadcrumbs main="Form Layout" title="Step Form Wizard" />
    <div class="container-fluid">
        <div class="row">
            <customHorizontal />
            <businessVertical />
            <customVertical />
            <businessHorizontal />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const customHorizontal = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/customHorizontal.vue"))
const businessVertical = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/businessVertical.vue"))
const customVertical = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/customVertical.vue"))
const businessHorizontal = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/formwizard2/businessHorizontal.vue"))
</script>